// CHG-1307 / ITER-3434 — v2 Adoption telemetry dashboard API client.
//
// Thin wrapper over the platform-admin /api/v1/platform/v2-adoption
// endpoint. Returns the same TypeScript shapes the MetricsDashboard
// composition primitive consumes (StatStripData / TimeSeriesData /
// FunnelData).

import { apiClient } from "./client";
import type {
  StatStripData,
  TimeSeriesData,
  FunnelData,
} from "../components/composition/MetricsDashboard";

export interface V2AdoptionResponse {
  org_id: string | null;
  generated_at: string;
  stat_strip: StatStripData;
  time_series: TimeSeriesData;
  funnel: FunnelData;
}

export const v2AdoptionApi = {
  async fetch(orgId?: string | null): Promise<V2AdoptionResponse> {
    const params = orgId ? { org_id: orgId } : undefined;
    const resp = await apiClient().get<V2AdoptionResponse>(
      "/platform/v2-adoption",
      { params },
    );
    return resp.data;
  },
};
